export const mapperResponseToDetail = (detail, showDraft) => {
  let detailMapped = {};

  if (
    detail.state === "PUBLISH_NO_DRAFT" ||
    (detail.state === "PUBLISH_WITH_DRAFT" && !showDraft)
  ) {
    detailMapped = {
      ...detail,
      content: {
        ...detail?.publishContent,
      },
    };
    delete detailMapped?.publishContent;
  } else {
    detailMapped = {
      ...detail,
      content: {
        ...detail?.draftContent,
      },
    };
    delete detailMapped?.draftContent;
  }
  return detailMapped;
};
